module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAACCAYAAABL0bx/AAAAAXNSR0IArs4c6QAAAB5JREFUCB1jfC4xbdX///9DGegAGBkZw5joYA+KFQD6dQXukhihWwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Line_5.png
// module id = 301
// module chunks = 7